<template>
  <!-- No BlockFieldset: the block has no fields, and viewer generates and downloads the ZIP. -->
  <div class="project-bank-summary">
    <p v-if="isNewProject" class="text-muted">{{ $t('saveNewProjectFirst') }}</p>
    <p v-else>
      {{ $t('combinedBankAttachmentsZip') }}
      <ZipDownload
        :attachmentType="BANK_ZIP_ATTACHMENT_TYPE"
        :attachments="zipAttachments"
        :project="project"
        :dynamic="true"
        :fetchBuildState="reloadBlock"
      />
    </p>
  </div>
</template>

<script>
import ZipDownload from '@/components/ZipDownload';
import { BANK_GENERATED_ATTACHMENT_TYPES } from '@/helpers/bankAttachmentTypes';
import { ProjectBankBlockMixin } from '@/mixins/projectBankBlock';
import { PROJECT_BANK_SUMMARY_FIELDS } from './projectBankSummaryFragment';

const BANK_ZIP_ATTACHMENT_TYPE = BANK_GENERATED_ATTACHMENT_TYPES.BANK_ATTACHMENTS_ZIP;

/**
 * Block project-bank-summary ("Zusammenfassung", tab Bank, see feature page projekt-bank):
 * generates the ZIP of all bank documents and downloads it. Viewer is enough, so the block has no
 * read-only state. `project` is the block data (`Project.blocks.bankSummary`); the build state
 * poll reloads it. On the unsaved project it shows only a hint.
 */
export default {
  name: 'ProjectBankSummary',
  components: { ZipDownload },
  mixins: [ProjectBankBlockMixin],
  bankBlockField: 'bankSummary',
  bankBlockFragment: PROJECT_BANK_SUMMARY_FIELDS,
  props: {
    blockId: { type: String, required: true },
    project: { type: Object, required: true },
  },
  data() {
    return { BANK_ZIP_ATTACHMENT_TYPE };
  },
  computed: {
    zipAttachments() {
      return (this.project.bank?.attachments ?? []).filter(
        (attachment) => attachment.attachmentType === BANK_ZIP_ATTACHMENT_TYPE
      );
    },
  },
};
</script>
